module.exports = __webpack_public_path__ + "img/hr-branch-particle-07.70e46e9b.png";